export class Support {

  constructor (THREE) {
    this.THREE = THREE
    this.groupSupp = new this.THREE.Group()
    this.raycaster = new this.THREE.Raycaster()
    this.suppColor = 0x8e44ad
  }

  addShape (shape, color, x, y, z, rx, ry, rz, s) {
    // flat shape
    var geometry = new this.THREE.ShapeBufferGeometry(shape)
    var mesh = new this.THREE.Mesh(geometry, new this.THREE.MeshPhongMaterial({ color: color, side: this.THREE.DoubleSide }))
    mesh.rotation.order = 'ZYX'
    rx = rx / 180 * Math.PI
    ry = ry / 180 * Math.PI
    rz = rz / 180 * Math.PI
    mesh.rotation.set(rx, ry, rz)
    mesh.position.set(x, y, z)
    mesh.scale.set(s, s, s)
    this.groupSupp.add(mesh)
  }

  draw (scene, group, _params) {
    const criticalAngle = _params.criticalAngle
    const restrictedFaces = _params.restrictedFaces
    const allowedFaces = _params.allowedFaces
    const supportConfig = _params.supportConfig
    // --- BEGIN GRID LINES
    this.clear(scene)

    // let material = new this.this.THREE.MeshPhongMaterial({ color: 0xffffff, specular: 0x111111, shininess: 200, vertexColors: this.this.THREE.VertexColors })
    // this.group.children.material = material
    // console.log(this.group.children.material)
    // console.log("I am here")

    // describe teeth configuration
    let Ot = 0.8
    let Ob = 0.8
    let Tt = 0.5
    let Tb = 0.5
    let Wt = 0.5
    let Wb = 0.8
    let Pt = 0.16
    let Pb = 0.16
    if (supportConfig) {
      Ot = supportConfig.Ot[0]
      Ob = supportConfig.Ob[0]
      Tt = supportConfig.Tt[0]
      Tb = supportConfig.Tb[0]
      Wt = supportConfig.Wt[0]
      Wb = supportConfig.Wb[0]
      Pt = supportConfig.Pt[0]
      Pb = supportConfig.Pb[0]
    }

    var distanceSet = 1
    var cosine35 = Math.cos((criticalAngle / 180) * Math.PI)
    var bbox = new this.THREE.Box3().setFromObject(group)
    var zPosition = 0

    // fix distance if using number of supports
    // largestDim = Math.max(bbox.max.x - bbox.min.x,
    //     Math.max(bbox.max.y - bbox.min.y, bbox.max.z - bbox.min.z));
    var largestDimX = bbox.max.x - bbox.min.x
    var largestDimY = bbox.max.y - bbox.min.y
    var halfLargestDistanceX = largestDimX / 2
    var halfLargestDistanceY = largestDimY / 2
    var supportnumberX = Math.ceil(largestDimX / distanceSet)
    var supportnumberY = Math.ceil(largestDimY / distanceSet)
    var distanceX = largestDimX / supportnumberX// (radius * 2) / supportnumber;
    var distanceY = largestDimY / supportnumberY

    // find height of object
    var objHight5pc = (bbox.max.z - bbox.min.z) * 0.05 + bbox.min.z
    var currentEuler = new this.THREE.Euler(group.rotation.x, group.rotation.y, group.rotation.z, 'ZYX')
    var direction = new this.THREE.Vector3(0, 0, 1)

    // --- BEGIN INTERSECTING LINES.
    for (var x = 0; x <= supportnumberX; x++) {
      for (var y = 0; y <= supportnumberY; y++) {
        var xPosition = -halfLargestDistanceX + (distanceX * x)
        var yPosition = -halfLargestDistanceY + (distanceY * y)

        var begin = new this.THREE.Vector3(xPosition, yPosition, zPosition)

        this.raycaster.set(begin, direction)// direction.sub(origin).normalize()
        var intersections = this.raycaster.intersectObjects(group.children, true)

        // if there are intersections then process
        if (intersections.length) {
          // since ray will enter/exit object then 0, 2, 4, ... are the ends of the supports
          // 1, 3, 5, ... are the starts of the supports
          // Note: assumes that intersects are ordered by distance!
          for (var i = 0; i < intersections.length; i += 2) {
            let faceIndex = intersections[i].faceIndex
            const idxRestricted = restrictedFaces.indexOf(Math.floor(faceIndex / 3))
            const idxAllowed = allowedFaces.indexOf(Math.floor(faceIndex / 3))
            // console.log("faceIndex "+faceIndex);
            // console.log("idxRestricted "+idxRestricted);
            // console.log("idxAllowed "+idxAllowed);
            // get point leaving last surface if i>0
            // var lastPointZ = zPosition - spreaderIncrement;
            if (idxRestricted === -1) {
              var lastPointZ = zPosition
              if (i > 0) {
                lastPointZ = intersections[i - 1].point.z
              }
              // get y coordinate of end intersection
              var newPointZ = intersections[i].point.z
              // get and transform face normal
              var inormal = intersections[i].face.normal
              inormal.applyEuler(currentEuler)
              // get cosine of face normal to the ray
              var cosangle = inormal.dot(new this.THREE.Vector3(0, 0, -1.0))// /inormal.length();
              // var idistance = intersections[0].distance;
              // if >35' then add support
              if (idxAllowed > -1 || cosangle > cosine35 || newPointZ <= objHight5pc) {
                let startx = xPosition
                let starty = yPosition
                let startz = lastPointZ
                // let endx = xPosition
                // let endy = yPosition
                let endz = newPointZ
                let rectLength = distanceSet * Math.sqrt(2.0)
                // let rectWidth = endz - startz
                var rectShape = new this.THREE.Shape()
                if (startz < 1e-9) {
                  // console.log("11111")
                  rectShape.moveTo(rectLength / 2, startz)
                  rectShape.lineTo(0, startz)
                  rectShape.lineTo(0, endz - Ot - Tt)
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz - Ot)
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz + Pt)
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz + Pt)
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz - Ot)
                  rectShape.lineTo(rectLength, endz - Ot - Tt)
                  rectShape.lineTo(rectLength, startz)
                  rectShape.lineTo(rectLength / 2, startz)
                } else {
                  // console.log("22222")
                  rectShape.moveTo(rectLength / 2, startz - Pb)
                  rectShape.lineTo((rectLength - Wb * rectLength) * 0.5, startz - Pb)
                  rectShape.lineTo((rectLength - Wb * rectLength) * 0.5, startz + Ob)
                  rectShape.lineTo(0, startz + Ob + Tb)
                  rectShape.lineTo(0, endz - Ot - Tt)
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz - Ot)
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5, endz + Pt)
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz + Pt)
                  rectShape.lineTo((rectLength - Wt * rectLength) * 0.5 + Wt * rectLength, endz - Ot)
                  rectShape.lineTo(rectLength, endz - Ot - Tt)
                  rectShape.lineTo(rectLength, startz + Ob + Tb)
                  rectShape.lineTo(rectLength - (rectLength - Wt * rectLength) * 0.5, startz + Ob)
                  rectShape.lineTo(rectLength - (rectLength - Wt * rectLength) * 0.5, startz - Pb)
                  rectShape.moveTo(rectLength / 2, startz - Pb)
                }
                this.addShape(rectShape, this.suppColor, startx - distanceSet / 2, starty - distanceSet / 2, 0, 90, 0, 45, 1)
                this.addShape(rectShape, this.suppColor, startx - distanceSet / 2, starty + distanceSet / 2, 0, 90, 0, -45, 1)
              }
            }
          }
        }
      }
    }
    scene.add(this.groupSupp)
    // console.log('I am in support');
  };

  clear (scene) {
    // console.log('I am in clear');
    scene.remove(this.groupSupp)
    this.groupSupp = new this.THREE.Group()
  };
}



// WEBPACK FOOTER //
// ./src/services/viewer/support.js